var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ball-grid-pulse loader",class:( _obj = {}, _obj[_vm.size] = true, _obj[_vm.color] = true, _obj )},_vm._l((_vm.ball_count),function(index){return _c('div',{key:index})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }